<template>
  <span>
    <div class="container" v-if="!addContactOptions">
      <!-- yes or no -->
      <div class="card">
        <!-- Title -->
        <div class="card-title align-end">
          <h1>
            Add <span class="highlight-cn">{{ term }} </span>as a new contact?
          </h1>
        </div>

        <!-- Action -->
        <div class="card-action align-center">
          <button class="orange-button" @click="showAddContactOptions">
            Yes
          </button>
          <button class="orange-button" @click="emptyTerm">No</button>
        </div>

        <div class="card-footer align-end">
          <p
            class="orange-text small-text cursor-pointer"
            @click="toggleFullResultList"
          >
            {{ showFullResultList ? "Hide all contacts" : "Show all contacts" }}
          </p>
        </div>
      </div>
    </div>

    <!-- option -->
    <add-user-expansion
      v-else
      :option-selected="optionSelected"
      :term="term"
      :show-expansion="showExpansion"
      :toggle-expansion="toggleExpansion"
    />
  </span>
</template>

<script>
import AddUserExpansion from "./AddUserExpansion";

export default {
  name: "ContactNotFound",
  props: {
    term: String, // The search term
    emptyTerm: Function, // Hide the section
    optionSelected: Function, // When add client/person/event/group option is selected
    toggleFullResultList: Function, // Show the full result list
    showFullResultList: Boolean // Weather to show the full result list
  },
  data() {
    return {
      addContactOptions: false, // Weather to show the add contact form or not
      showExpansion: true // Show the expansion or not
    };
  },
  components: {
    AddUserExpansion // The add user expansion
  },
  methods: {
    /**
     * Show the add contact options
     */
    showAddContactOptions() {
      this.addContactOptions = true;
    },
    /**
     * Hide the add contact options
     */
    hideAddContactOptions() {
      this.addContactOptions = false;
    },
    /**
     * Toggle expansion
     */
    toggleExpansion() {
      this.showExpansion = !this.showExpansion;
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
}

.card {
  display: flex;
  flex-direction: column;
}

.card-title {
  margin: 5px;
}

.card-action {
  margin: 5px;
}
.highlight-cn {
  color: #d26d13;
  font-weight: bold;
}
.orange-button {
  background: #d26d13;
  color: #fff;
  padding: 4px 20px;
  border: 0;
  border-radius: 5px;
  margin-left: 15px;
  outline: none;
  cursor: pointer;
}

.orange-button:hover {
  background-color: #fb5e00;
}

.orange-button:active {
  background-color: #fb5e00;
}

button {
  transition: all 0.2s ease-in-out;
}

.card-footer {
  margin-top: 10px;
  margin-right: 5px;
}

.orange-text {
  color: #d26d13;
}

.small-text {
  font-size: 12px;
}

.cursor-pointer {
  cursor: pointer;
}

.align-end {
  align-self: flex-end;
}
.align-center {
  align-self: center;
}

div >>> .hide-border {
  border-bottom: none !important;
}

div >>> .dropdown-link {
  border: 1px solid #ccc;
  padding: 10px;
  position: relative;
  cursor: pointer;
}

div >>> .dropdown-link span {
  background: #fff;
  width: 20px;
  height: 20px;
  display: inline-block;
  position: absolute;
  top: 8px;
  right: 10px;
}
</style>
